// extracted by mini-css-extract-plugin
export var addButton = "_ox-0";
export var border = "_ox-8";
export var check = "_ox-h";
export var danger = "_ox-6";
export var dropdownContainer = "_ox-1";
export var editModalBody = "_ox-j";
export var footerContainer = "_ox-i";
export var fullWidth = "_ox-a";
export var hide = "_ox-9";
export var icon = "_ox-3";
export var input = "_ox-7";
export var inputFlex = "_ox-b";
export var inputWrapper = "_ox-c";
export var manualFocus = "_ox-5";
export var optionButton = "_ox-4";
export var pillWrapper = "_ox-e";
export var pointer = "_ox-2";
export var showOverflow = "_ox-f";
export var tagsFlex = "_ox-d";
export var xButton = "_ox-g";